import { render, staticRenderFns } from "./ReviewTakCard.vue?vue&type=template&id=32f67cee&scoped=true"
import script from "./ReviewTakCard.vue?vue&type=script&lang=js"
export * from "./ReviewTakCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f67cee",
  null
  
)

export default component.exports